import { useCallback } from "react";
import { useSearchParams } from "react-router";
import { isToday, isValid, parse, startOfToday } from "date-fns";
import { machineFormat } from "@medoma/models/date-and-time";

const DATE_SEARCH_PARAM = "date";
const DATE_KEY_FORMAT = "yyyy-MM-dd";

const useSelectedDateNoDefault = () => {
  const [searchParams] = useSearchParams();
  const dateParam = searchParams.get(DATE_SEARCH_PARAM);
  const parsed = dateParam
    ? parse(dateParam, DATE_KEY_FORMAT, new Date())
    : undefined;
  return parsed && isValid(parsed) ? parsed : undefined;
};

export const useSelectedDate = () => {
  return useSelectedDateNoDefault() ?? startOfToday();
};

export const useSelectedDateKey = () => {
  return machineFormat(useSelectedDate(), DATE_KEY_FORMAT);
};

export const useSelectedDateIsToday = () => {
  return isToday(useSelectedDate());
};

export const useSetSelectedDate = () => {
  const [, setSearchParams] = useSearchParams();
  return useCallback(
    (dateKey: string) => {
      setSearchParams(
        (prev) => {
          const next = new URLSearchParams(prev);
          next.set(DATE_SEARCH_PARAM, dateKey);
          return next;
        },
        { replace: true },
      );
    },
    [setSearchParams],
  );
};
